import { DealerDetailsListViewModel } from './../business-entities/dealer-details-view-model';
import { DealerRequestModel, DealerViewModel } from './../business-entities/dealer-view-model';
import { DealerNotificationViewModel } from './../business-entities/notification-details-result-view-model';
import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service'
import { DealerServiceDetailsListViewModel } from '../business-entities/dealer-service-details-list-view-model';
import { DealerHolidayViewModel } from '../business-entities/dealer-holiday-list-view-model';
import { Country } from '../business-entities/country.model';
import { DealerBrandViewModel } from '../business-entities/dealer-brand-view-model';
import { ManualNotificationRequestModel, ManualTemplateDetailModel, TemplateLegendRequestModel } from '../business-entities/manual-notification-model';
import { OlbDealerConfigViewModel, OlbDealerDetailViewModel, OlbDealerViewModel } from '../business-entities/olb-dealer.model';

@Injectable({
    providedIn: 'root'
})

export class DealerDataService {
    constructor(private dataProvider: DataService) {
    }
    async getDealerList(dealerRequestModel:DealerRequestModel): Promise<GenericResponse<Array<DealerViewModel>>> {
        return this.dataProvider.Post<GenericResponse<Array<DealerViewModel>>>(Urls.GetDealerList,dealerRequestModel).toPromise();
    }
    async getDealerBrandList(): Promise<any> {
        return this.dataProvider.GetAll<any>(Urls.GetDealerBrandList).toPromise();
    }
    async getDealerNotificationList(dealerId: string): Promise<GenericResponse<DealerNotificationViewModel>> {
        return this.dataProvider.Get<GenericResponse<DealerNotificationViewModel>>(Urls.GetDealerNotificationList,dealerId).toPromise();
    }
    getManualNotificationData(requestModel: any): Promise<GenericResponse<ManualTemplateDetailModel>> {
        return this.dataProvider.GetAllwithHeaders<GenericResponse<ManualTemplateDetailModel>>(Urls.GetManualNotificationData,requestModel).toPromise();
    }

    async getDealerDetails(dealerId: string): Promise<GenericResponse<DealerDetailsListViewModel>> {
        return this.dataProvider.Get<GenericResponse<DealerDetailsListViewModel>>
            (Urls.GetDealerDetails, dealerId).toPromise();
    }
    SendNotification(model: ManualNotificationRequestModel):Promise<any>{
        return this.dataProvider.Post<GenericResponse<boolean>>(Urls.SendNotification, model).toPromise();
    }
    updateDealer(dealerDetails: DealerViewModel): Promise<GenericResponse<any>> {
        return this.dataProvider.Put<GenericResponse<boolean>>(Urls.UpdateDealerDetails, dealerDetails).toPromise();
    }
    AddRecipient(model:any):Promise<any>{
        return this.dataProvider.Post<GenericResponse<boolean>>(Urls.AddRecipient, model).toPromise();
    }
    AddToNotification(model:any):Promise<any>{
        return this.dataProvider.Post<GenericResponse<boolean>>(Urls.AddToNotification, model).toPromise();
    }
    getMyRecipientList(dealerId: string):Promise<any>{
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetMyRecipientList,dealerId).toPromise();
    }
    addDealer(dealerDetails: DealerViewModel): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddDealerDetails, dealerDetails).toPromise();
    }
    addDealerNotificationDetails(dealerNotifications: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddDealerCommunicationDetails, dealerNotifications).toPromise();
    }
    addDealerBrand(dealerBrandDetails: DealerBrandViewModel): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddDealerBrand, dealerBrandDetails).toPromise();
    }
    deleteDealerBrand(dealerBrandDetails: DealerBrandViewModel): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.DeleteDealerBrand, dealerBrandDetails).toPromise();
    }
    editDealerBrand(dealerBrandDetails: DealerBrandViewModel): Promise<GenericResponse<any>> {
        return this.dataProvider.Put<GenericResponse<any>>(Urls.EditDealerBrand, dealerBrandDetails).toPromise();
    }

    async deleteDealer(dealerId: string): Promise<GenericResponse<number>> {
        return this.dataProvider.Delete<GenericResponse<number>>(Urls.DeleteDealer, dealerId).toPromise();
    }

    async getDealerServiceList(dealerId: string, language:string): Promise<GenericResponse<DealerServiceDetailsListViewModel>> {
        return this.dataProvider.Get<GenericResponse<DealerServiceDetailsListViewModel>>(Urls.GetDealerServiceList, dealerId, language).toPromise();
    }

    async getDealerWiseHolidayList(dealerId: string): Promise<GenericResponse<Array<DealerHolidayViewModel>>> {
        return this.dataProvider.Get<GenericResponse<Array<DealerHolidayViewModel>>>(Urls.GetDealerWiseHolidayList, dealerId).toPromise();
    }

    async getAllCountries(): Promise<GenericResponse<Country[]>> {
        return this.dataProvider.Get<GenericResponse<Country[]>>(Urls.GetCountries).toPromise();
    }

    async GetDealerWorkingHoursAndHoliday(dealerId: string): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetDealerWorkingHoursAndHoliday, dealerId).toPromise();
    }

    async getUserDealersDropdown(): Promise<any> {
        return this.dataProvider.GetAll<any>(Urls.GetUserDealersDropdown).toPromise();
    }

    async getLocationCode(): Promise<any> {
        return this.dataProvider.GetAll<any>(Urls.GetLocationCode).toPromise();
    }

    async getNotificationPreview(requestModel:TemplateLegendRequestModel): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetNotificationPreview, requestModel).toPromise();
    }

    async OlbGetDealers(name: string): Promise<GenericResponse<Array<OlbDealerViewModel>>> {
        return this.dataProvider.Get<GenericResponse<Array<OlbDealerViewModel>>>(Urls.OlbGetDealers, name).toPromise();
    }
    async OlbGetDealerDetail(dealerDmsNo: string): Promise<GenericResponse<OlbDealerDetailViewModel>> {
        return this.dataProvider.Get<GenericResponse<OlbDealerDetailViewModel>>(Urls.OlbGetDealerDetail, dealerDmsNo).toPromise();
    }
    async OlbGetDealerConfig(dealerDmsNo: string): Promise<GenericResponse<OlbDealerConfigViewModel>> {
        return this.dataProvider.Get<GenericResponse<OlbDealerConfigViewModel>>(Urls.OlbGetDealerConfig, dealerDmsNo).toPromise();
    }
    async ResyncDealer(dealerId: string): Promise<GenericResponse<boolean>> {
        return this.dataProvider.Get<GenericResponse<boolean>>(Urls.ResyncDealer, dealerId).toPromise();
    }
    async GetWidgetServiceReport(model:any): Promise<GenericResponse<any>>{
        return this.dataProvider.Post<GenericResponse<boolean>>(Urls.GetWidgetServiceReport, model).toPromise();
    }
}